import { render } from "./LivingUnitDetails.vue?vue&type=template&id=76df3d56&scoped=true"
import script from "./LivingUnitDetails.vue?vue&type=script&lang=js"
export * from "./LivingUnitDetails.vue?vue&type=script&lang=js"

import "./LivingUnitDetails.vue?vue&type=style&index=0&id=76df3d56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76df3d56"]])

export default __exports__